import React, { Component } from "react";
import styled from "styled-components";
import { TableSortable } from '@loanbossinc/component-library';
import { dashboardBodyDataTableClosedDealColumns } from './AcquisitionsDataTableDealColumns';
import { filterByParameter } from '../dashboard.filters';
import { DashboardBodyDefaultHeader } from "../DashboardBodyDefaultHeader";

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export class AcquisitionsDataTable extends Component {
  getDeals = () => {
    const { items, searchText } = this.props;
    const list = items && items.length ? [...items] : [];
    const mappedItems = this.mapColumns(list);
    return filterByParameter(mappedItems, searchText, 'name');
  }

  getUnits = (item) => {
    if (!item || !item.dealMetricsV2) return '--';
    return !item.dealMetricsV2.mfunits ? `${item.dealMetricsV2.squareFeet} SF` : `${item.dealMetricsV2.mfunits} Units`
  }

  mapColumns = (items) => {
    return items.map(item => ({
      id: item.id
      , name: item.name
      , unit: this.getUnits(item)
      , targetedClosing: item.targetedClosing
      , purchasePrice: item.dealMetricsV2 && item.dealMetricsV2.purchasePrice
    }));
  }

  render() {
    const {
      title
      , onRowClick
      , onSearchChange
      , searchText
      , onToggleChange
      , toggleOptions
      , menuOptions
      , childDealsFilter
    } = this.props;

    return (
      <StyledWrapper>
      {childDealsFilter}
        <DashboardBodyDefaultHeader
          title={title}
          toggleOptions={toggleOptions}
          onToggleChange={onToggleChange}
          onSearchChange={onSearchChange}
          searchText={searchText}
          menuOptions={menuOptions}
        />

        <TableSortable
          columns={dashboardBodyDataTableClosedDealColumns}
          items={this.getDeals()}
          onRowClick={(item) => onRowClick(item)}
          noDataMessage='No Deals Found'
        />
      </StyledWrapper>
    );
  }
}